<div class="legal-page">
  <!-- ════════════════ HERO BANNER ════════════════ -->
  <header class="legal-hero">
    <div class="legal-hero-inner">
      <!-- Breadcrumb -->
      <nav class="legal-hero-breadcrumb">
        <a routerLink="/">Início</a>
        <i class="fas fa-chevron-right"></i>
        <span>Política de Privacidade</span>
      </nav>

      <!-- Eyebrow -->
      <div class="legal-hero-eyebrow">
        <i class="fas fa-user-shield"></i>
        <span>Governança de Dados & Protecção da Privacidade</span>
      </div>

      <!-- Title & Subtitle -->
      <h1 class="legal-hero-title">
        Política de <em>Privacidade</em> — FundCube
      </h1>

      <p class="legal-hero-desc">
        Compromisso firme com a protecção, integridade, confidencialidade e tratamento transparente de dados pessoais,
        em estrita conformidade com a <strong>Lei n.º 22/11, de 17 de Junho (LPDP)</strong> e os padrões internacionais
        de protecção de dados (RGPD).
      </p>

      <!-- Quick Metadata Pills -->
      <div class="legal-hero-meta">
        <span class="meta-pill">
          <i class="fas fa-code-branch"></i> Versão: <strong>{{ versaoDocumento }}</strong>
        </span>
        <span class="meta-pill">
          <i class="fas fa-calendar-check"></i> Em vigor desde: <strong>{{ dataActualizacao }}</strong>
        </span>
        <span class="meta-pill">
          <i class="fas fa-id-card"></i> NIF: <strong>5001399934</strong>
        </span>
        <span class="meta-pill">
          <i class="fas fa-building-shield"></i> Autoridade: <strong>APD Angola</strong>
        </span>
        <span class="meta-pill">
          <i class="fas fa-location-dot"></i> Luanda, Angola
        </span>
      </div>

      <!-- Actions Bar -->
      <div class="legal-hero-actions">
        <button type="button" class="btn-action-hero" (click)="printDocument()">
          <i class="fas fa-print"></i> Imprimir Política
        </button>
        <button type="button" class="btn-action-hero" (click)="copyLink()">
          <i class="fas" [ngClass]="copySuccess ? 'fa-check text-emerald-300' : 'fa-link'"></i>
          <span>{{ copySuccess ? 'Ligação Copiada!' : 'Partilhar Ligação' }}</span>
        </button>
      </div>
    </div>

    <!-- Onda decorativa de transição inferior -->
    <div class="legal-hero-wave">
      <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        <path d="M0,40 C360,80 1080,0 1440,40 L1440,60 L0,60 Z" fill="#f8fafb" />
      </svg>
    </div>
  </header>

  <!-- ════════════════ CORPO PRINCIPAL ════════════════ -->
  <main class="container legal-main-container">
    <div class="legal-layout-grid">
      <!-- ── SIDEBAR / SUMÁRIO STICKY ── -->
      <aside class="legal-sidebar">
        <div class="legal-toc-card">
          <div class="toc-header">
            <i class="fas fa-list-ol"></i>
            <span>Índice do Documento</span>
          </div>

          <nav class="toc-nav">
            <button type="button" *ngFor="let sec of sections" class="toc-item"
              [class.active]="activeSectionId === sec.id" (click)="scrollTo(sec.id)">
              <span class="toc-num">{{ sec.number }}</span>
              <span class="toc-text">{{ sec.title }}</span>
            </button>
          </nav>

          <div class="toc-contact-card">
            <div class="tcc-icon"><i class="fas fa-shield-halved"></i></div>
            <div class="tcc-title">Encarregado de Protecção de Dados (DPO)</div>
            <p class="tcc-desc">Amândio Chaves · Responsável pela Privacidade e Conformidade Legal da FundCube.</p>
            <a href="mailto:amandio.chaves@fundcube.ao" class="tcc-link">
              <i class="fas fa-envelope"></i> Contactar DPO
            </a>
          </div>
        </div>
      </aside>

      <!-- ── CONTEÚDO LEGAL COMPLETO ── -->
      <article class="legal-content-body">

        <!-- RESUMO INFORMATIVO INICIAL -->
        <div class="legal-callout-card">
          <div class="lcc-icon"><i class="fas fa-circle-info"></i></div>
          <div class="lcc-body">
            <h4>Compromisso Institucional de Protecção de Dados</h4>
            <p>
              A <strong>FundCube, Promoção de Investimentos LDA</strong> reconhece a importância fulcral de cumprir a
              legislação e regulamentação sobre a privacidade e protecção de dados, a aplicar no contexto de todas as
              actividades da sua instituição, independentemente de o tratamento desses dados ocorrer dentro ou fora do
              País. Estamos integralmente comprometidos em proteger a integridade, confidencialidade e disponibilidade
              dos dados pessoais nos nossos sistemas de informação, salvaguardando a privacidade dos nossos clientes,
              parceiros e colaboradores.
            </p>
          </div>
        </div>

        <!-- ════ 1. ÂMBITO E APLICABILIDADE ════ -->
        <section id="seccao-1" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-file-shield"></i> Secção 1</div>
            <h2 class="section-block-title">1. Âmbito e Aplicabilidade</h2>
          </header>

          <div class="section-block-body">
            <p>
              A <strong>FundCube, Promoção de Investimentos LDA</strong>, com o NIF <strong>5001399934</strong> e sede
              social na Rua Rey Katyavala, n.º 1149, Edifício Rey Katyavala, Luanda, República de Angola, explora e gere
              a plataforma tecnológica FundCube (<strong>fundcube.ao</strong>).
            </p>
            <p>
              A FundCube é a entidade formalmente responsável pelo tratamento dos seus dados pessoais, nos termos da
              <strong>Lei n.º 22/11, de 17 de Junho (Lei da Protecção de Dados Pessoais - LPDP)</strong> e, no que
              aplicável internacionalmente aos fluxos transfronteiriços, do Regulamento Geral de Protecção de Dados
              (RGPD/UE). O tratamento de dados da FundCube está registado e notificado junto da <strong>Agência de
                Protecção de Dados (APD)</strong> de Angola.
            </p>

            <div class="highlight-subbox step-flow-box">
              <div class="subbox-title">
                <i class="fas fa-users-viewfinder"></i> Destinatários e Sujeitos Abrangidos
              </div>
              <p class="mb-2">A presente Política de Privacidade aplica-se expressamente a:</p>
              <ul class="styled-legal-list">
                <li><strong>Colaboradores e Prestadores:</strong> Todos os colaboradores internos, programadores e
                  demais intervenientes que acedem ou operam os sistemas de informação da FundCube;</li>
                <li><strong>Criadores / Promotores:</strong> Pessoas singulares ou colectivas que mantêm conta registada
                  e criam ou gerem campanhas de angariação na plataforma FundCube;</li>
                <li><strong>Apoiantes:</strong> Cidadãos e organizações que realizam contribuições ou doações, com ou
                  sem conta de utilizador previamente criada;</li>
                <li><strong>Visitantes:</strong> Qualquer utilizador que navegue ou consulte informações
                  disponibilizadas no portal e nos seus subdomínios.</li>
              </ul>
            </div>

            <div class="highlight-subbox">
              <div class="subbox-title">
                <i class="fas fa-scale-balanced"></i> Definição Legal de Dados Pessoais
              </div>
              <p>
                Para efeitos do presente documento e da legislação em vigor, entende-se por <strong>«Dados
                  Pessoais»</strong> toda e qualquer informação relativa a uma pessoa singular identificada ou
                identificável («titular dos dados»).
              </p>
              <p class="text-sm text-slate-600 mt-2 mb-0">
                É considerada identificável uma pessoa singular que possa ser identificada, directa ou indirectamente,
                designadamente por referência a um nome, um número de identificação civil ou fiscal, dados de
                localização, identificadores por via electrónica (como endereço IP e cookies essenciais) ou a um ou mais
                elementos específicos da sua identidade física, fisiológica, económica, cultural ou social.
              </p>
            </div>

            <p class="legal-cross-note">
              <i class="fas fa-book-bookmark text-primary mr-1"></i> Ao utilizar a FundCube, aplicam-se conjuntamente os
              nossos
              <a routerLink="/termos-condicoes" class="text-primary font-bold hover:underline">Termos e Condições de
                Adesão</a>.
            </p>
          </div>
        </section>

        <!-- ════ 2. DADOS PESSOAIS TRATADOS ════ -->
        <section id="seccao-2" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-database"></i> Secção 2</div>
            <h2 class="section-block-title">2. Dados Pessoais Tratados</h2>
          </header>

          <div class="section-block-body">
            <p>
              Em observância ao princípio da minimização, são tratados única e exclusivamente os dados estritamente
              necessários para viabilizar cada operação e funcionalidade da plataforma.
            </p>

            <!-- Tabela de Categorias de Dados -->
            <div class="table-responsive-wrapper my-4">
              <table class="legal-table">
                <thead>
                  <tr>
                    <th>Categoria</th>
                    <th>Exemplos de Dados Recolhidos</th>
                    <th>Titulares dos Dados</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Conta</strong></td>
                    <td>Nome completo, endereço de correio electrónico (email), número de telefone, palavra-passe
                      (guardada de forma estritamente cifrada e irreversível).</td>
                    <td>Criadores e apoiantes com conta registada</td>
                  </tr>
                  <tr>
                    <td><strong>Perfil Público</strong></td>
                    <td>Nome de exibição ou nome artístico, fotografia de perfil/logótipo, biografia/descrição, ligações
                      para redes sociais oficiais.</td>
                    <td>Criadores / Promotores</td>
                  </tr>
                  <tr>
                    <td><strong>Apoios e Doações</strong></td>
                    <td>Valor monetário da contribuição, data e hora, referência de pagamento e estado da transacção.
                    </td>
                    <td>Apoiantes</td>
                  </tr>
                  <tr>
                    <td><strong>Comentários</strong></td>
                    <td>Conteúdo dos comentários e reacções publicados nas campanhas, associados ao nome público da
                      conta ou anonimato escolhido.</td>
                    <td>Autores dos comentários</td>
                  </tr>
                  <tr>
                    <td><strong>Recompensas</strong></td>
                    <td>Recompensa seleccionada e opções inerentes (ex.: tamanho, cor); para recompensas de entrega
                      física: morada de entrega postal e telefone de contacto para logística.</td>
                    <td>Apoiantes que seleccionam recompensas físicas ou digitais</td>
                  </tr>
                  <tr>
                    <td><strong>Recebimento / Repasse</strong></td>
                    <td>Número de Identificação Bancária (IBAN), nome do titular da conta bancária, número de Bilhete de
                      Identidade (BI) e Número de Identificação Fiscal (NIF).</td>
                    <td>Criadores / Promotores que movimentam fundos</td>
                  </tr>
                  <tr>
                    <td><strong>Verificação e Segurança</strong></td>
                    <td>Códigos de validação temporários (OTP) enviados por email ou WhatsApp, e respectivo resultado de
                      confirmação de identidade.</td>
                    <td>Titulares de conta e promotores verificados</td>
                  </tr>
                  <tr>
                    <td><strong>Dados Técnicos</strong></td>
                    <td>Endereço IP, tipo de dispositivo móvel ou computador, navegador de internet (browser), registos
                      automáticos de acesso (logs) e registos de erro.</td>
                    <td>Todos os utilizadores e visitantes</td>
                  </tr>
                  <tr>
                    <td><strong>Comunicações</strong></td>
                    <td>Histórico de mensagens trocadas com o suporte ao cliente, pedidos de apoio ou formulários de
                      contacto institucional.</td>
                    <td>Quem nos contacta directamente</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Dados NÃO recolhidos (Alerta) -->
            <div class="highlight-subbox alert-style">
              <div class="subbox-title">
                <i class="fas fa-shield-virus"></i> Dados que a FundCube NÃO recolhe nem armazena
              </div>
              <p>
                Para salvaguardar ao máximo a privacidade e integridade financeira dos utilizadores, a FundCube
                <strong>nunca recolhe nem guarda</strong>:
              </p>
              <ul class="styled-legal-list">
                <li><strong>Dados integrais de cartões bancários:</strong> Números de cartão, datas de validade ou
                  códigos de segurança (CVV/CVC);</li>
                <li><strong>Códigos PIN ou chaves de segurança:</strong> Credenciais bancárias confidenciais (tratadas
                  exclusivamente pelos gateways bancários homologados);</li>
                <li><strong>Dados biométricos ou genéticos:</strong> Impressões digitais ou reconhecimento facial;</li>
                <li><strong>Localização geográfica contínua:</strong> Rastreio de GPS ou localização em tempo real;</li>
                <li><strong>Acesso a componentes privados:</strong> Acesso à lista de contactos telefónicos, calendário,
                  microfone ou câmara sem autorização explícita e temporária.</li>
              </ul>
            </div>

            <div class="principles-box mt-4">
              <h4 class="font-bold text-slate-800 mb-2">Princípios Fundamentais do Tratamento</h4>
              <p class="text-sm text-slate-600 mb-2">
                Os dados fornecidos na relação estabelecida com a FundCube são tratados em rigorosa conformidade com os
                seguintes preceitos legalmente aplicáveis:
              </p>
              <div class="values-grid">
                <div class="value-item">
                  <div class="vi-icon"><i class="fas fa-scale-balanced"></i></div>
                  <div>
                    <strong>a) Licitude, Lealdade e Transparência</strong>
                    <p>Tratados sempre de forma lícita, leal e com transparência total perante o titular dos dados.</p>
                  </div>
                </div>
                <div class="value-item">
                  <div class="vi-icon"><i class="fas fa-bullseye"></i></div>
                  <div>
                    <strong>b) Finalidade Determinada e Legítima</strong>
                    <p>Recolhidos para finalidades explícitas e legítimas, não sendo tratados de forma incompatível.</p>
                  </div>
                </div>
                <div class="value-item">
                  <div class="vi-icon"><i class="fas fa-filter"></i></div>
                  <div>
                    <strong>c) Minimização e Adequação</strong>
                    <p>Adequados, pertinentes e limitados estritamente ao necessário para as finalidades de tratamento.
                    </p>
                  </div>
                </div>
                <div class="value-item">
                  <div class="vi-icon"><i class="fas fa-hourglass-half"></i></div>
                  <div>
                    <strong>d) Limitação da Conservação</strong>
                    <p>Conservados de forma a permitir a identificação apenas durante o período estritamente necessário.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- ════ 3. FINALIDADES, FUNDAMENTOS E PRAZOS ════ -->
        <section id="seccao-3" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-calendar-check"></i> Secção 3</div>
            <h2 class="section-block-title">3. Finalidades, Fundamentos Legais e Prazos de Conservação</h2>
          </header>

          <div class="section-block-body">
            <p>
              Cada utilização de dados na FundCube possui um fundamento legal claro e um prazo de conservação
              pré-estabelecido. Findo o período estipulado, os dados são definitivamente eliminados ou anonimizados
              irreversivelmente para fins puramente estatísticos.
            </p>

            <!-- Tabela de Finalidades e Prazos -->
            <div class="table-responsive-wrapper my-4">
              <table class="legal-table">
                <thead>
                  <tr>
                    <th>Finalidade do Tratamento</th>
                    <th>Dados Envolvidos</th>
                    <th>Fundamento Legal</th>
                    <th>Prazo de Conservação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Criar e gerir a conta de utilizador</strong></td>
                    <td>Dados de conta, identificação e verificação</td>
                    <td>Execução do contrato (Termos e Condições de Uso)</td>
                    <td>Enquanto a conta estiver activa + 2 anos após encerramento</td>
                  </tr>
                  <tr>
                    <td><strong>Apresentar a página pública do criador e da campanha</strong></td>
                    <td>Perfil público, fotografias e ligações do projecto</td>
                    <td>Execução do contrato</td>
                    <td>Até o criador alterar ou remover a respectiva informação</td>
                  </tr>
                  <tr>
                    <td><strong>Processar apoios e liquidar valores aos criadores</strong></td>
                    <td>Dados de apoios, IBAN e comprovativos bancários</td>
                    <td>Execução do contrato e cumprimento de obrigação legal</td>
                    <td>10 anos (obrigações contabilísticas e fiscais legais em Angola)</td>
                  </tr>
                  <tr>
                    <td><strong>Publicar comentários e interacções comunitárias</strong></td>
                    <td>Conteúdo dos comentários, reacções e nome da conta</td>
                    <td>Execução do contrato</td>
                    <td>Até o autor remover o comentário ou a campanha ser eliminada</td>
                  </tr>
                  <tr>
                    <td><strong>Viabilizar a entrega de recompensas pelo criador</strong></td>
                    <td>Dados de recompensa, nome, email, morada física e telefone</td>
                    <td>Execução do contrato de financiamento</td>
                    <td>Até à confirmação de entrega + 6 meses para eventuais reclamações</td>
                  </tr>
                  <tr>
                    <td><strong>Prevenir fraudes e proteger a estabilidade da plataforma</strong></td>
                    <td>Registos técnicos, endereços IP, histórico de apoios e acessos</td>
                    <td>Interesse legítimo de segurança e obrigação legal</td>
                    <td>12 meses para registos e logs técnicos de segurança</td>
                  </tr>
                  <tr>
                    <td><strong>Cumprir disposições legais e ordens de autoridades públicas</strong></td>
                    <td>Os dados estritamente necessários a cada determinação legal</td>
                    <td>Cumprimento de obrigação legal</td>
                    <td>O prazo fixado na lei aplicável ou na decisão judicial/regulamentar</td>
                  </tr>
                  <tr>
                    <td><strong>Responder a pedidos de suporte e atendimento ao cliente</strong></td>
                    <td>Histórico de comunicações e mensagens trocadas</td>
                    <td>Execução do contrato e interesse legítimo</td>
                    <td>2 anos após a conclusão do último contacto de suporte</td>
                  </tr>
                  <tr>
                    <td><strong>Enviar novidades, campanhas e comunicados FundCube</strong></td>
                    <td>Endereço de correio electrónico (email) e telefone</td>
                    <td>Consentimento livre e informado do utilizador</td>
                    <td>Até o utilizador retirar o respectivo consentimento (opt-out)</td>
                  </tr>
                  <tr>
                    <td><strong>Medir audiência e métricas agregadas de utilização do portal</strong></td>
                    <td>Dados técnicos anonimizados e cookies de análise</td>
                    <td>Consentimento do utilizador</td>
                    <td>Até 13 meses</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="legal-doc-banner">
              <div class="ldb-content">
                <i class="fas fa-hand-holding-heart text-emerald-600 text-2xl mr-3"></i>
                <div>
                  <strong class="text-emerald-950 block text-base mb-1">Garantia de Não Comercialização de
                    Dados</strong>
                  <span class="text-emerald-800 text-sm">
                    A FundCube <strong>não vende nem aluga</strong> os seus dados pessoais a quaisquer terceiros ou
                    agências de publicidade. Se, no futuro, houver necessidade de tratar dados para qualquer nova
                    finalidade incompatível, notificaremos previamente os titulares e, quando legalmente exigido,
                    solicitaremos o devido consentimento.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- ════ 4. SISTEMA DE PAGAMENTOS E INFORMAÇÃO PÚBLICA ════ -->
        <section id="seccao-4" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-credit-card"></i> Secção 4</div>
            <h2 class="section-block-title">4. Sistema de Pagamentos e Informação Pública</h2>
          </header>

          <div class="section-block-body">
            <h3 class="subsection-title"><i class="fas fa-lock text-primary mr-2"></i>Processamento de Pagamentos e
              Parcerias</h3>
            <p>
              Os pagamentos e liquidações financeiras na plataforma FundCube são processados através de prestadores de
              serviços de pagamento autorizados, nomeadamente a <strong>AppyPay</strong> e a rede interbancária nacional
              (GPO / Multicaixa Express / Transferência Bancária), entidades que possuem as suas próprias políticas de
              privacidade e padrões de segurança de grau bancário.
            </p>
            <p>
              Quando efectua uma doação ou apoio, introduz os seus dados de pagamento directamente no ambiente seguro
              desses prestadores. A FundCube recebe exclusivamente o valor transaccionado, a referência de confirmação e
              o estado de sucesso da operação.
            </p>
            <p class="text-sm text-slate-600 bg-slate-100 p-3 rounded-lg border border-slate-200">
              <i class="fas fa-university text-slate-700 mr-2"></i>
              As obrigações legais de identificação e diligência perante clientes para prevenção do branqueamento de
              capitais e do financiamento do terrorismo são rigorosamente cumpridas pela AppyPay e pela FundCube, em
              obediência à <strong>Lei n.º 05/20, de 27 de Janeiro</strong> e normas do Banco Nacional de Angola (BNA).
            </p>

            <h3 class="subsection-title mt-4"><i class="fas fa-eye text-primary mr-2"></i>Visibilidade dos Dados: O Que
              Fica Público vs. Privado</h3>
            <div class="highlight-subbox">
              <ul class="styled-legal-list">
                <li><strong>Perfil do Criador:</strong> O nome público, a imagem de capa, o vídeo de apresentação e as
                  ligações para redes sociais associadas à campanha são públicos;</li>
                <li><strong>Valores de Doações Individuais:</strong> O montante exacto doado por cada apoiante
                  individual não é exposto publicamente por pré-definição;</li>
                <li><strong>Apoios Sem Recompensa:</strong> Caso o apoiante contribua sem requerer recompensa física, o
                  criador não tem acesso à identidade do mesmo, salvo autorização voluntária do doador;</li>
                <li><strong>Comentários e Mensagens Comunitárias:</strong> Os comentários postados no separador da
                  campanha são públicos e podem ser assinados com o nome de perfil ou de forma anónima, conforme
                  preferência seleccionada no momento da submissão.</li>
              </ul>
            </div>

            <h3 class="subsection-title mt-4"><i class="fas fa-gift text-primary mr-2"></i>Recompensas e
              Responsabilidade dos Criadores</h3>
            <p>
              Sendo a FundCube uma plataforma de crowdfunding colaborativo de recompensas, a produção e remessa das
              recompensas (físicas ou digitais) é da inteira responsabilidade do Criador da campanha. Para esse efeito
              exclusivo:
            </p>
            <ul class="legal-numbered-list">
              <li>O Criador recebe exclusivamente os dados indispensáveis à entrega: nome, email e, para entregas
                postais, morada e contacto telefónico;</li>
              <li>Nos termos contratuais de adesão, o Criador compromete-se a usar tais dados única e exclusivamente
                para concretizar o envio da recompensa prometida, devendo apagá-los de seguida;</li>
              <li>A partir do momento em que recebe legitimamente os dados para expedição, o Criador passa a ser
                autónomo e directamente responsável pela guarda e tratamento dos dados no âmbito da respectiva remessa.
              </li>
            </ul>
          </div>
        </section>

        <!-- ════ 5. PARTILHA DE DADOS COM TERCEIROS ════ -->
        <section id="seccao-5" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-handshake"></i> Secção 5</div>
            <h2 class="section-block-title">5. Com Quem Partilhamos Dados</h2>
          </header>

          <div class="section-block-body">
            <p>
              A FundCube partilha dados estritamente na medida do indispensável à prestação dos serviços e ao
              cumprimento da legislação em vigor, com os seguintes destinatários:
            </p>

            <div class="table-responsive-wrapper my-4">
              <table class="legal-table">
                <thead>
                  <tr>
                    <th>Entidade / Destinatário</th>
                    <th>Motivo e Finalidade Específica</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>AppyPay e Bancos Parceiros</strong></td>
                    <td>Processamento seguro de transacções, recebimento de doações e transferência de fundos angariados
                      aos promotores.</td>
                  </tr>
                  <tr>
                    <td><strong>Criador / Promotor da Campanha</strong></td>
                    <td>Entrega da recompensa escolhida: nome, email e, no caso de bens físicos, morada de envio e
                      telefone de contacto (apenas dos apoiantes que optaram por recompensa).</td>
                  </tr>
                  <tr>
                    <td><strong>Fornecedores de Infraestrutura (Microsoft Azure, Serviços de Email)</strong></td>
                    <td>Garantir o funcionamento e disponibilidade ininterrupta da plataforma na nuvem, sob acordos
                      contratuais de sigilo e rigorosas instruções técnicas da FundCube.</td>
                  </tr>
                  <tr>
                    <td><strong>Equipa Técnica e Programadores Autorizados</strong></td>
                    <td>Desenvolvimento contínuo, correcção de anomalias e manutenção do software, com termos formais de
                      confidencialidade e acesso restrito a dados produtivos.</td>
                  </tr>
                  <tr>
                    <td><strong>Autoridades Públicas, Tribunais, BNA e APD</strong></td>
                    <td>Cumprimento estrito de deveres legais, combate à fraude financeira e atendimento a ordens
                      judiciais ou administrativas emanadas de entidades reguladoras de Angola.</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p class="text-sm text-slate-600 mt-2">
              Os dados pessoais poderão ser transmitidos adicionalmente a: (a) autoridades supervisoras, regulatórias ou
              fiscais para declaração, exercício ou defesa de direitos em processos judiciais; (b) instituições do mesmo
              grupo empresarial para efeitos de gestão da relação contratual e prevenção à fraude; (c) prestadores de
              tecnologias da informação, analytics e auditores externos independentes devidamente credenciados.
            </p>
          </div>
        </section>

        <!-- ════ 6. COOKIES E MEDIDAS DE SEGURANÇA ════ -->
        <section id="seccao-6" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-cookie-bite"></i> Secção 6</div>
            <h2 class="section-block-title">6. Regras de Utilização de Cookies e Segurança</h2>
          </header>

          <div class="section-block-body">
            <h3 class="subsection-title"><i class="fas fa-cookie text-primary mr-2"></i>Utilização de Cookies</h3>
            <p>
              Utilizamos cookies estritamente necessários para permitir a navegação no portal, gerir a sua sessão
              autenticada, recordar preferências básicas e assegurar a protecção contra acessos indevidos. Por serem
              essenciais à operacionalidade e segurança da plataforma, estes cookies não carecem de consentimento
              prévio.
            </p>
            <p class="font-semibold text-slate-700">
              <i class="fas fa-ban text-red-500 mr-2"></i>
              A FundCube não utiliza cookies invasivos de rastreio de terceiros para publicidade comportamental.
            </p>

            <h3 class="subsection-title mt-4"><i class="fas fa-shield-halved text-primary mr-2"></i>Medidas Técnicas e
              Organizativas de Segurança</h3>
            <p>
              Os dados de todos os utilizadores são protegidos através de protocolos avançados de segurança da
              informação:
            </p>
            <div class="values-grid my-3">
              <div class="value-item">
                <div class="vi-icon"><i class="fas fa-lock"></i></div>
                <div>
                  <strong>Cifra em Trânsito (HTTPS/TLS)</strong>
                  <p>Todas as comunicações entre o seu navegador e a plataforma são cifradas com certificados SSL de
                    alta segurança.</p>
                </div>
              </div>
              <div class="value-item">
                <div class="vi-icon"><i class="fas fa-key"></i></div>
                <div>
                  <strong>Hashing Irreversível de Palavras-passe</strong>
                  <p>As palavras-passe são guardadas com algoritmos criptográficos modernos de sentido único,
                    inacessíveis até mesmo a administradores.</p>
                </div>
              </div>
              <div class="value-item">
                <div class="vi-icon"><i class="fas fa-user-lock"></i></div>
                <div>
                  <strong>Acesso Restrito Baseado em Funções (RBAC)</strong>
                  <p>O acesso aos dados produtivos é estritamente limitado aos profissionais que necessitam deles para
                    tarefas operacionais específicas.</p>
                </div>
              </div>
              <div class="value-item">
                <div class="vi-icon"><i class="fas fa-server"></i></div>
                <div>
                  <strong>Cópias de Segurança Cifradas (Backups)</strong>
                  <p>Backups periódicos e redundantes, armazenados em ambientes seguros com encriptação em repouso.</p>
                </div>
              </div>
            </div>

            <div class="highlight-subbox alert-style">
              <div class="subbox-title">
                <i class="fas fa-bell"></i> Notificação de Violação de Dados Pessoais
              </div>
              <p>
                Na eventualidade de ocorrer um incidente de segurança ou violação de dados pessoais que represente um
                risco para os direitos e liberdades dos titulares, a FundCube notificará a <strong>Agência de Protecção
                  de Dados (APD)</strong> e as pessoas afectadas <strong>sem demora injustificada</strong>, detalhando a
                natureza do incidente, os dados envolvidos e as medidas de mitigação em curso.
              </p>
            </div>
          </div>
        </section>

        <!-- ════ 7. DIREITOS DO TITULAR DOS DADOS ════ -->
        <section id="seccao-7" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-user-check"></i> Secção 7</div>
            <h2 class="section-block-title">7. Direitos do Titular dos Dados</h2>
          </header>

          <div class="section-block-body">
            <p>
              Nos termos da Lei n.º 22/11 (LPDP) e das boas práticas internacionais, o titular dos dados pessoais tem o
              direito de solicitar à FundCube, a qualquer momento e mediante pedido escrito:
            </p>

            <div class="rights-grid my-4">
              <div class="right-card">
                <div class="rc-badge">a</div>
                <div class="rc-content">
                  <h5>Direito de Acesso</h5>
                  <p>Aceder às informações e dados pessoais que lhe digam respeito e que sejam objecto de tratamento
                    pela FundCube.</p>
                </div>
              </div>

              <div class="right-card">
                <div class="rc-badge">b</div>
                <div class="rc-content">
                  <h5>Direito de Rectificação</h5>
                  <p>Solicitar a correcção ou actualização de dados pessoais inexactos, incorrectos ou desactualizados.
                  </p>
                </div>
              </div>

              <div class="right-card">
                <div class="rc-badge">c</div>
                <div class="rc-content">
                  <h5>Direito de Complementação</h5>
                  <p>Exigir o preenchimento ou integração de dados pessoais que se encontrem incompletos.</p>
                </div>
              </div>

              <div class="right-card">
                <div class="rc-badge">d</div>
                <div class="rc-content">
                  <h5>Direito de Eliminação (Esquecimento)</h5>
                  <p>Requerer a eliminação definitiva dos seus dados nos casos especificamente previstos na lei, desde
                    que não colida com prazos legais imperativos.</p>
                </div>
              </div>

              <div class="right-card">
                <div class="rc-badge">e</div>
                <div class="rc-content">
                  <h5>Direito de Limitação do Tratamento</h5>
                  <p>Solicitar a suspensão temporária do tratamento enquanto se aprecia a exactidão dos dados ou a
                    licitude da operação.</p>
                </div>
              </div>

              <div class="right-card">
                <div class="rc-badge">f</div>
                <div class="rc-content">
                  <h5>Direito de Revogação do Consentimento</h5>
                  <p>Retirar a qualquer altura o consentimento previamente outorgado, sem que isso invalide o tratamento
                    efectuado até essa data.</p>
                </div>
              </div>

              <div class="right-card">
                <div class="rc-badge">g</div>
                <div class="rc-content">
                  <h5>Direito de Oposição</h5>
                  <p>Opor-se ao tratamento de dados por motivos relacionados com a sua situação particular, quando o
                    tratamento se fundar em interesses legítimos.</p>
                </div>
              </div>

              <div class="right-card">
                <div class="rc-badge">h</div>
                <div class="rc-content">
                  <h5>Direito à Portabilidade</h5>
                  <p>Receber os dados pessoais fornecidos num formato digital de uso corrente, estruturado e de leitura
                    automática.</p>
                </div>
              </div>
            </div>

            <!-- Canal de Exercício de Direitos -->
            <div class="highlight-subbox step-flow-box">
              <div class="subbox-title">
                <i class="fas fa-paper-plane"></i> Como Exercer os Seus Direitos
              </div>
              <p>
                Para exercer qualquer dos seus direitos legais, envie uma comunicação escrita para o endereço
                electrónico:
                <strong class="text-emerald-800">geral@fundcube.ao</strong> ou para o DPO em
                <strong class="text-emerald-800">amandio.chaves@fundcube.ao</strong>.
              </p>
              <ul class="styled-legal-list mt-2">
                <li>A FundCube enviará uma resposta formal no prazo máximo de <strong>30 dias</strong>;</li>
                <li>Por motivos de segurança, poderemos solicitar a prévia confirmação da sua identidade através do
                  correio electrónico ou contacto telefónico associado à conta;</li>
                <li>Poderá cancelar o recebimento de novidades promocionais a qualquer momento clicando no link de
                  desinscrição disponibilizado no rodapé de cada email enviado.</li>
              </ul>
            </div>
          </div>
        </section>

        <!-- ════ 8. MENORES ════ -->
        <section id="seccao-8" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-child-reaching"></i> Secção 8</div>
            <h2 class="section-block-title">8. Protecção de Menores</h2>
          </header>

          <div class="section-block-body">
            <p>
              A utilização dos serviços da FundCube para a criação de campanhas de angariação e o recebimento de fundos
              é estritamente reservada a cidadãos com idade igual ou superior a <strong>18 anos</strong> dotados de
              plena capacidade civil.
            </p>
            <p>
              Caso a FundCube tome conhecimento de que foram recolhidos ou tratados inadvertidamente dados pessoais de
              um menor de idade sem a devida e comprovada autorização parental ou tutela legal, tais dados serão
              <strong>imediatamente eliminados</strong> dos nossos servidores e arquivos.
            </p>
          </div>
        </section>

        <!-- ════ 9. ALTERAÇÕES A ESTA POLÍTICA ════ -->
        <section id="seccao-9" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-clock-rotate-left"></i> Secção 9</div>
            <h2 class="section-block-title">9. Alterações a Esta Política</h2>
          </header>

          <div class="section-block-body">
            <p>
              A versão actualizada e em vigor da presente Política de Privacidade encontra-se permanentemente acessível
              no endereço electrónico <strong>fundcube.ao/politica-privacidade</strong>.
            </p>
            <p>
              Em caso de alterações materiais (tais como novas categorias de dados tratados, novas finalidades ou
              transmissão a novas entidades), os utilizadores serão devidamente notificados através de correio
              electrónico ou por aviso de destaque na plataforma com uma antecedência mínima de <strong>15 (quinze)
                dias</strong> relativamente à data da sua entrada em vigor, sendo recolhido novo consentimento nos casos
              em que a lei o exija.
            </p>
          </div>
        </section>

        <!-- ════ 10. CONTACTOS E ENCARREGADO DE DADOS (DPO) ════ -->
        <section id="seccao-10" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-address-book"></i> Secção 10</div>
            <h2 class="section-block-title">10. Contactos Institucionais</h2>
          </header>

          <div class="section-block-body">
            <p>
              Para esclarecimentos adicionais, dúvidas sobre o tratamento de dados ou comunicações regulatórias, utilize
              os seguintes canais:
            </p>

            <div class="contacts-grid my-4">
              <div class="contact-card-item">
                <div class="cci-icon"><i class="fas fa-building"></i></div>
                <div class="cci-body">
                  <h4>Entidade Responsável</h4>
                  <p><strong>FundCube, Promoção de Investimentos LDA</strong></p>
                  <p class="text-xs text-slate-500">NIF: 5001399934</p>
                  <p class="text-xs text-slate-500">Rua Rey Katyavala, Edifício Rey Katyavala, n.º 1149, Luanda, Angola
                  </p>
                  <a href="mailto:geral@fundcube.ao" class="cci-link"><i class="fas fa-envelope"></i>
                    geral@fundcube.ao</a>
                  <a href="tel:+244940762031" class="cci-link"><i class="fas fa-phone"></i> +244 940 762 031</a>
                </div>
              </div>

              <div class="contact-card-item highlight">
                <div class="cci-icon"><i class="fas fa-user-shield"></i></div>
                <div class="cci-body">
                  <h4>Encarregado de Protecção de Dados (DPO)</h4>
                  <p><strong>Amândio Chaves</strong></p>
                  <p class="text-xs text-slate-500">Gabinete de Privacidade e Protecção de Dados</p>
                  <a href="mailto:amandio.chaves@fundcube.ao" class="cci-link"><i class="fas fa-envelope"></i>
                    amandio.chaves@fundcube.ao</a>
                </div>
              </div>

              <div class="contact-card-item">
                <div class="cci-icon"><i class="fas fa-landmark"></i></div>
                <div class="cci-body">
                  <h4>Autoridade de Supervisão</h4>
                  <p><strong>Agência de Protecção de Dados (APD)</strong></p>
                  <p class="text-xs text-slate-500">Autoridade Pública Independente da República de Angola</p>
                  <p class="text-xs text-slate-500">Registo de Tratamento e Supervisão Nacional</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- ════ 11. ENTRADA EM VIGOR ════ -->
        <section id="seccao-11" class="legal-section-block">
          <header class="section-block-header">
            <div class="sbh-badge"><i class="fa-solid fa-flag-checkered"></i> Secção 11</div>
            <h2 class="section-block-title">11. Entrada em Vigor</h2>
          </header>

          <div class="section-block-body">
            <p>
              A presente <strong>Política de Privacidade da FundCube</strong> entra em vigor e produz plenos efeitos
              jurídicos na data da sua publicação e divulgação oficial, a <strong>16 de Outubro de 2026</strong>.
            </p>
            <div class="legal-closure-box mt-4">
              <p class="mb-1 text-slate-500 text-xs uppercase tracking-wider font-semibold">FundCube, Promoção de
                Investimentos LDA</p>
              <p class="mb-0 text-slate-700 font-medium">Todos os direitos reservados © 2026</p>
            </div>
          </div>
        </section>

      </article>
    </div>
  </main>
</div>

<!-- ════ NEWSLETTER COMPONENT ════ -->
<app-newsletter />